/* Análise → Por obra: ranking por escopo e tabela com percentuais. */

import { api } from '../../core/api';
import { esc, lista, nf, num, pct } from '../../core/formato';
import type { PorObra } from '../../tipos/api';
import { carregar } from '../../ui/carregar';
import { legendaEscopos, loading, tabela } from '../../ui/componentes';
import { setHtml } from '../../ui/dom';
import { filtrosBar, paramsFiltro } from '../../ui/filtros';
import { barrasEmpilhadas } from '../../ui/graficos';
import type { Pagina } from '../pagina';

export const obras: Pagina = {
  render: () => `
  <h1 class="page">Emissões por obra</h1>
  <p class="sub">Cada obra é uma unidade de negócio cadastrada para a empresa. Informe a obra ao lançar para ela aparecer aqui.</p>
  ${filtrosBar({ escopo: true })}
  <div class="grid" style="grid-template-columns:minmax(0,1fr) minmax(0,1.3fr);align-items:start">
    <div class="card"><h2 class="sec">Ranking</h2>${legendaEscopos()}<div id="aObrasBar">${loading()}</div></div>
    <div id="aObrasTab">${loading()}</div>
  </div>`,

  carregar(tk) {
    carregar(tk, [{
      id: 'aObrasTab', tambem: ['aObrasBar'],
      busca: () => api<PorObra[]>('GET', '/por-obra', { params: paramsFiltro() }),
      html: (d: PorObra[]) => {
        const l = lista<PorObra>(d);
        const tot = l.reduce((a, x) => a + num(x.total_emissoes), 0);
        const soma = (k: keyof PorObra) => l.reduce((a, x) => a + num(x[k]), 0);
        setHtml('aObrasBar', barrasEmpilhadas(l.slice(0, 10).map((u) => ({ l: u.unidade_negocio || 'Sem obra informada', v: [u.escopo_1, u.escopo_2, u.escopo_3].map(num) }))));
        return tabela<PorObra>([
          { l: 'Obra', f: (x) => `<b>${esc(x.unidade_negocio || 'Sem obra informada')}</b>` },
          { l: 'Escopo 1', r: true, f: (x) => nf(x.escopo_1, 2) },
          { l: 'Escopo 2', r: true, f: (x) => nf(x.escopo_2, 2) },
          { l: 'Escopo 3', r: true, f: (x) => nf(x.escopo_3, 2) },
          { l: 'Total tCO₂e', r: true, f: (x) => `<b>${nf(x.total_emissoes, 2)}</b>` },
          { l: '%', r: true, f: (x) => pct(x.total_emissoes, tot) },
        ], l, ['Total', nf(soma('escopo_1'), 2), nf(soma('escopo_2'), 2), nf(soma('escopo_3'), 2), nf(tot, 2), l.length ? '100%' : '—']);
      },
    }]);
  },
};
